import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Container, FormFeedback, Input, Label,  Row, Col} from 'reactstrap';

import ClubList from '../club/ClubList';

import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import { run, validationRunner } from '../validation/validationRunner'

const fieldValidations = [
  validationRunner("EndDate", "Lid tot", Validations.validDate , Validations.validDateRange),
]



class RegistrationFormActivityData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      validationErrors: [],
      fieldsTouched: [],
      showPreviousActivity: false,

      UnionSport: [],
      ClubSport: [],
      NonPlayingMember: false,
      PreviousClub: "",
      RelationCode: "",
      EndDate: "",
    };

    this.handleChangeUnionSports = this.handleChangeUnionSports.bind(this);
    this.handleChangeClubSports = this.handleChangeClubSports.bind(this);
    this.handleChangeNonPlayingMember = this.handleChangeNonPlayingMember.bind(this);

    this.handleChange = FormLogic.handleChange.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.handleChangeToUpper = FormLogic.handleChangeToUpper.bind(this);

    this.run = run.bind(this);
  }


  componentDidUpdate() {
    this.runValidations();
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true;
    }
    return this.run(fieldValidations);
  }

  getFormValues() {
    var unionSports = []
    this.state.UnionSport.forEach(sportid =>
      unionSports.push({SportId: sportid})
    )
    var clubSports = []
    this.state.ClubSport.forEach(sportid =>
      clubSports.push({SportId: sportid})
    )
    const clubId = (this.state.showPreviousActivity) ? this.state.PreviousClub : "";
    const endDate = (this.state.showPreviousActivity) ? FormLogic.toDateFormat(this.state.EndDate) : "";
    const relationCode = (this.state.showPreviousActivity) ?this.state.RelationCode : "";

    return {
      "UnionSport" : unionSports,
      "ClubSport" : clubSports,
      "PreviousClubMembership": {
        "ClubId" : clubId,
        "EndDate" : endDate,
        "RelationCode" : relationCode
      }
    }
  }

  handleChangeNonPlayingMember(event) {
    this.setState({NonPlayingMember: event.target.checked});
    this.props.setIsUnionMember(event.target.checked);
    if (event.target.checked) {
      // Clear other values
      this.setState({'UnionSport': []});
    }
  }

  handleChangeUnionSports(event) {
    const value = parseInt(event.target.id, 10);
    var newValue = event.target.checked ? [value] : [];
    this.setState({'UnionSport': newValue});

    // Make sure unionmember state is still valid
    if (event.target.checked) {
      this.props.setIsUnionMember(true);
      this.setState({NonPlayingMember: false});
    } else {
      this.props.setIsUnionMember(false);
    }

  }

  handleChangeClubSports(event) {
    const value = parseInt(event.target.id, 10)
    var newValue = event.target.checked ? this.state['ClubSport'].concat(value) : this.state['ClubSport'].filter((val) => val!==value);
    this.setState({'ClubSport': newValue})
  }


  render() {

    return (
      <Container>
        <h2 className="TextCenter">
          Lidmaatschap
        </h2>
        <Row>
          <p className="FormDescription">
            Het belangrijkste deel van je aanmelding bij {this.props.clubName} is
            de sport en activiteit die je wilt gaan beoefenen.
            Binnen {this.props.clubName} kunnen verschillende sporten of activiteiten
            worden beoefend. Kies hieronder de gewenste activiteiten.
          </p>
        </Row>


        <Row className="ActivityRow">
          <Col md={{size:9, offset:1}}>
            {this.props.unionSport && this.props.unionSport.map((sport) =>
              <FormGroup key={sport.SportId} className="checkBox" check>
                <Input
                  name="UnionSport"
                  id={sport.SportId}
                  type="checkbox"
                  checked={this.state.UnionSport.indexOf(sport.SportId) > -1}
                  onChange={this.handleChangeUnionSports} />{' '}
                <Label htmlFor={sport.SportId} check> {sport.SportDescription} (tevens bondslid {this.props.unionid})</Label>
              </FormGroup> )}


              <FormGroup className="checkBox" check>
                <Input
                  name="UnionMembership"
                  id="UnionMembership"
                  type="checkbox"
                  checked={this.state.NonPlayingMember}
                  onChange={this.handleChangeNonPlayingMember} />{' '}
                <Label htmlFor="UnionMembership" check> niet spelend lid (tevens bondslid {this.props.unionid}) </Label>
              </FormGroup>
          </Col>
        </Row>

        <Row hidden={this.props.clubSport && this.props.clubSport.length === 0 } className="ActivityRow">
            <p className="FormDescription">
              <strong>{this.props.clubName} </strong> heeft ook de volgende clubactiviteiten:
            </p>
          <Col md={{size:9, offset:1}}>
            {this.props.clubSport && this.props.clubSport.map((sport) =>
              <FormGroup key={sport.SportId} className="checkBox" check>
                <Input
                  name="ClubSport"
                  id={sport.SportId}
                  type="checkbox"
                  checked={this.state.ClubSport.indexOf(sport.SportId) > -1}
                  onChange={this.handleChangeClubSports} />{' '}
                <Label htmlFor={sport.SportId} check> {sport.SportDescription}</Label>
              </FormGroup> )}
          </Col>
        </Row>

        <Row>
          <p className="FormDescription">
            Ben je al eerder lid geweest of ben je nog lid van een vereniging die aangesloten is bij de {this.props.unionid}?
          </p>
        </Row>

        <Row className="">
          <Col md={{size:9, offset:1}}>
              <FormGroup className="checkBox" check>
                <Label check>
                  <Input
                    name="PreviousActiveYes"
                    type="radio"
                    autoComplete="ignored-123456"
                    value="yes"
                    onChange={() => this.setState({showPreviousActivity: true})}
                    />
                  Ja
                </Label>
                <br/>
                <Label check>
                  <Input
                    name="PreviousActiveYes"
                    type="radio"
                    autoComplete="ignored-123456"
                    value="no"
                    onChange={() => this.setState({showPreviousActivity: false})}
                     />
                   Nee
                   </Label>
              </FormGroup>
          </Col>
        </Row>





        <div hidden={!this.state.showPreviousActivity}>
          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label">Vorige vereniging</Label>
            </Col>
            <Col md={7}>
              <ClubList unionid={this.props.unionid} includeDissolved={true} maxItems={4} onclick={(club) => this.setState({'PreviousClub': club})}  />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label">Lid tot</Label>
            </Col>
            <Col md={7}>
              <Input
                name="EndDate"
                type="date"
                date-format="dd/mm/yyyy"
                autoComplete="ignored-123456"
                value={this.state.EndDate}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                invalid={this.checkInvalid("EndDate")}
                innerRef={(input) => { this.EndDate = input; }}
                className="Input" />
              <FormFeedback>{this.errorFor("EndDate")}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup  row>
            <Col md={{size:3, offset:1}} >
              <Label className="Label"> Relatiecode {this.props.unionid} </Label>
            </Col>
            <Col md={7}>
              <Input
                name="RelationCode"
                autoComplete="ignored-123456"
                value={this.state.RelationCode}
                onChange={this.handleChange}
                onBlur={this.setFieldsTouched}
                invalid={this.checkInvalid("RelationCode")}
                className="Input" />
              <FormFeedback>{this.errorFor("RelationCode")}</FormFeedback>
            </Col>
          </FormGroup>
        </div>


      </Container>
    );
  }
}

RegistrationFormActivityData.propTypes = {
  unionSport: PropTypes.array,
  clubSport: PropTypes.array,
  setIsUnionMember: PropTypes.func.isRequired,
  isUnionMember: PropTypes.bool.isRequired,
  unionid: PropTypes.string.isRequired,
  clubName: PropTypes.string.isRequired,
};

export default RegistrationFormActivityData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormActivityData.jsx